import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OccEndpointsService, ProductReference } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class RangeService {
  constructor(private readonly http: HttpClient, private readonly occEndpointsService: OccEndpointsService) {}

  getRange(productCode: string): Observable<{ references: ProductReference[] }> {
    const url: string = this.occEndpointsService.buildUrl('range', { urlParams: { productCode } });
    return this.http.get<{ references: ProductReference[] }>(url);
  }
}
